<template>
	<div class="main-header">
		<div class="custom-header">
			<router-link to="/" >
				<img class="logo" src="@/assets/images/logo@2x.png" />
			</router-link>
			<div class="menu">
				<router-link to="/" :class="['menu-item',{active: indexMenuList.includes(currentTab)}]">首页</router-link>
				<router-link to="/fabricHall" :class="['menu-item',{active: fabricHallMenuList.includes(currentTab)}]">面辅料馆</router-link>
				<router-link to="/home" :class="['menu-item',{active: communityPlazaMenuList.includes(currentTab)}]" v-if="false">社区广场</router-link>
				<router-link to="/mall" :class="['menu-item',{active: wholesalePlazaMenuList.includes(currentTab)}]">批发广场</router-link>
				<router-link to="/info" :class="['menu-item',{active: infoMenuList.includes(currentTab)}]">资讯</router-link>
				<router-link to="/contest" :class="['menu-item',{active: contestMenuList.includes(currentTab)}]" :style="{width:'80px'}">大赛 <span class="badge">火热报名</span></router-link>
			</div>
			<div :class="['search',{hidden: hiddenSearchMenuList.includes(currentTab)}]">
				<template v-if="!hiddenSearchMenuList.includes(currentTab)">
					<input placeholder="输入你想要的内容" class="search-input" v-model="keyword" @keyup.enter="onSearch" />
					<Icon v-if="keyword" type="md-close" size="20" style="cursor:pointer;" @click="clearSearch"></Icon>
					<img src="@/assets/images/icon-search.png" class="search-ico" @click="onSearch" />
				</template>
			</div>
			<div class="right-box">
				<Poptip trigger="hover" placement="bottom" :transfer="false" popper-class="creator-pop" width="180">
					<template #content>
						<div class="creator-box" ref="creatorBox">
							<div class="item-box">
								<div class="menu-item" @click="start_design">款式设计</div>
								<div class="menu-item" @click="onCreatePosts">发布笔记</div>
								<!-- <div class="menu-item">发布文章</div> -->
							</div>
						</div>
					</template>
					<Button ref="creatorBtn" icon="md-add" shape="circle" class="creator-btn" @click="start_design">款式设计</Button>
				</Poptip>

				<template v-if="!is_login">
					<div class="login-box">
						<img src="@/assets/images/icon-user-header.png" style="width:22px;height:24px;" />
						<div class="login-btn" @click="goLogin">登录/注册</div>
					</div>
					<!-- <div class="btn"  @click="goLogin">立即登录</div> -->
				</template>
				<template v-else>
					<div class="btn-wrap">
						<div class="msg-box" style="" @click="showChat()">
							<img src="@/assets/images/icon-header-msg.png" class="icon-msg" />
							<div class="msg-num" v-if="totalNum>0">{{totalNum}}</div>
						</div>
						<Poptip trigger="hover" placement="bottom-end">
							<template #content>
								<div class="avatar-dropdown-box">
									<div class="dropdown-top">
										<div class="dropdown-nick-avatar">
											<img :src="userInfo.avatar | default_img" class="dropdown-avatar" />
											<div class="dropdown-nick-job">
												<div class="dropdown-nick" style="">{{userInfo.nickname || userInfo.mobile}}</div>
												<div class="dropdown-job" style="">{{userInfo.city ? `${userInfo.city && userInfo.job ? userInfo.city+ '|' : userInfo.city}`:''}}{{userInfo.job || ''}}</div>
											</div>
										</div>
									</div>

									<div class="dropdown-items-lists">
										<div class="dropdown-item" v-for="(item,index) in menu_list" :key="index" @click="tab(item)">
											<img :src="item.iconImg | default_img" class="dropdown-item-icon" />
											<div class="dropdown-item-title">{{item.title}}</div>
										</div>
									</div>

									<div class="dropdown-logout">
										<div class="dropdown-logout-btn" @click="tab({path: 'logout'})">
											退出登录
										</div>
									</div>
								</div>
							</template>
							<span @click="go2center" style="cursor: pointer">我的</span>
							<img v-if="false" :src="userInfo.avatar|default_img" alt="" class="avatar" @click="go2center">
						</Poptip>
					</div>
				</template>
			</div>
      <portal to="global-layer">
        <create-posts v-if="show_creator_pop" @close-upload-pop="show_creator_pop = false" />
        <create-design v-if="show_design_pop" ref="createDesign" @close-design-pop="show_design_pop=false" @on-advanced-mode="(uuid)=>{start_design(uuid)}"></create-design>
        <chat ref="chat"></chat>
      </portal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Chat from "./Chat";
import CreateDesign from "./CreateDesign";
import CreatePosts from "./CreatePosts";
export default {
  name: "Header",
  components: {
    Chat,
    CreatePosts,
    CreateDesign
  },
  props: {
    show_back: {
      type: Boolean,
      default: false,
    },
    show_login: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      msg_count: 0,
      show_creator_pop: false,
      show_creator: false,
      menu_list: [
        {
          title: "我的工作台",
          path: "workbench/home",
          iconImg: require("../assets/images/icon-workbench-dropdown.png"),
        },
        {
          title: "我的店铺",
          path: "shop/manage",
          iconImg: require("../assets/images/icon-store-dropdown.png"),
        },
        {
          title: "我的款式",
          path: "style",
          iconImg: require("../assets/images/icon-style-dropdown.png"),
        },
        {
          title: "我的笔记",
          path: "design",
          iconImg: require("../assets/images/icon-design-dropdown.png"),
        },
        {
          title: "订单中心",
          path: "/order/center",
          iconImg: require("../assets/images/icon-order-dropdown.png"),
        },
        {
          title: "个人中心",
          path: "/workbench/center",
          iconImg: require("../assets/images/icon-mine-dropdown.png"),
        },
      ],
      keyword: "",
      route_name: "",
      show_design_pop:false,
	  indexMenuList: ['Index'], // 首页菜单列表
	  fabricHallMenuList: ['FabricHall', 'FabricHallSearch', 'FabricHallDetail'], // 面辅料馆菜单列表
	  communityPlazaMenuList: ['Home'], // 社区广场菜单列表
	  wholesalePlazaMenuList: ['Mall', 'GoodsList', 'GoodsDetail', 'MallShopCart', 'DesignerList', 'ShopHome'], // 批发广场菜单列表
	  infoMenuList: ['Info', 'InfoDetail'], // 资讯菜单列表
	  contestMenuList: ['Contest', 'ContestDetail'], // 大赛菜单列表
	  hiddenSearchMenuList: ['Index', 'FabricHall', 'FabricHallSearch', 'FabricHallDetail', 'GoodsDetail', 'MallShopCart', 'InfoDetail', 'ContestDetail', 'DesignerList', 'GoodsList', 'ShopHome'], // 隐藏搜索菜单列表
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      form_data: (state) => state.design.form_data,
      is_login: (state)=>state.is_login,
      setting: (state)=>state.setting
    }),
    ...mapGetters({
      totalNum: "scoket/totalNum",
    }),
    currentTab() {
      return this.$route.name;
    },
  },
  created() {
    if (this.is_login) {
      this.$store.dispatch("scoket/webSocketInit");
      this.$store.dispatch("scoket/getMessage");
    }
  },
  watch: {
    $route(to) {
      const { keyword } = to.params;
      if (keyword) {
        this.keyword = keyword;
      } else {
        this.keyword = "";
      }
    },
    "$route.name"(news) {
      this.route_name = news;
    },
    is_login(newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch("scoket/webSocketInit");
        this.$store.dispatch("scoket/getMessage");
      }
    },
  },
  methods: {
    // start_design(uuid) {
    //   this.show_creator = false;
    //   const params = {};
    //   uuid ? params.uuid = uuid : null;
    //   let route = this.$router.resolve({ name: "WorkBenchDesign",query:{...params} });
    //   window.open(route.href, "_blank");
    // },
    onSearch() {
		const { keyword } = this;
		// if (!keyword) {
		// 	this.$layer.msg("请输入搜索内容");
		// 	return;
		// }
		console.log(this.$route.name, keyword);
		this.searchUpdatePage();
    	//   this.$router.push({ name: "Search", params: { keyword } });
    },
	searchUpdatePage() {
		console.log(this.$route.name, this.keyword, this.currentTab);
		if (['Mall'].includes(this.$route.name)) {
			this.$router.push({ name: "GoodsList", params: { keyword: this.keyword } });
			return;
		} else {
			this.$EventBus.$emit('onHeaderSearch', { keyword: this.keyword });
			return;
		}
	},
	clearSearch() {
		this.keyword = '';
		this.searchUpdatePage();
	},
    showChat() {
      
      this.$refs["chat"].showChat();
    },
    onCreatePosts() {
      if (!this.is_login) {
        this.$layer.msg("请先登录");
        this.$router.replace({ name: "Login" });
        return;
      }
      this.show_creator_pop = true;
      // this.$router.push({
      // 	name:'Posts'
      // })
    },
    async tab(e) {
			const path = e.path;
			if(path != 'logout') {
      	await this.$store.dispatch('getUser');
			}
      await this.$store.dispatch('getUser');
      switch (path) {
        case "logout":
          this.$store.commit("clearLoginState");
          this.$router.push({
            path: "/",
          });
          break;
        case "workbench/home":
          this.$router.push({
            path: "/workbench/home",
          });
          break;
        case "style":
          this.$router.push({
            path: "/workbench/template",
          });
          break;
        case "shop/manage":
          if(!this.userInfo.shop_status || this.userInfo.shop_status != 1){
            console.log('店铺未开通');
            this.$router.push({
              name:"ShopApply",
              params:{sub_title:'申请开店'}
            })
            return;
          }
          this.$router.push({
            name: "ShopManage",
            query: {
              uid: this.userInfo.code,
            },
          });
          break;
        case "design":
          this.$router.push({ name: "MyCreations" });
          break;
        default:
          this.$router.push({
            path: e.path,
          });
          break;
      }
    },
    go2center() {
      this.$router.push({ name: "WorkBenchHome" });
    },
    start_design() {
      if(!this.is_login){
        this.$layer.msg('请先登录');
        this.$router.replace({ name: "Login" });
        return;
      }
      if(this.setting.is_quick_design_open > 0) {
        this.show_design_pop = true;
      } else {
        let route = this.$router.resolve({ name: "WorkBenchDesign" });
        window.open(route.href, "_blank");
      }
    },
    goBack() {
      this.$router.back();
    },
    goLogin() {
      // if (!this.$store.getters.isLoginDynamic()) {
      if (!this.is_login) {
        this.$store.commit("update_login_state", false);
        this.$router.push({
          path: "/login",
        });
        return;
      }
      this.$router.replace({
        path: "/user/center",
      });
    },
  },
};
</script>

<style scoped lang="scss">
	::v-deep .ivu-poptip-arrow {
		display: none !important;
	}

	::v-deep .ivu-poptip-content {
		border-radius: 15px !important;
	}

	::v-deep .ivu-poptip-inner {
		border-radius: 15px !important;
	}

	::v-deep .ivu-poptip-body {
		padding: 0px !important;
		background: #ffffff;
		box-shadow: 0px 0px 8px 0px #b3b3b3;
		border-radius: 15px !important;
	}

	.creator-box {
		background: #ffffff;
		// width: 170px;
		border-radius: 15px;
		font-size: 16px;
		text-align: left;
		margin: 10px 5px;

		.item-box {
			// padding:10px 0px;
			.menu-item {
				// width:170px;
				height: 45px;
				line-height: 45px;
				color: #000000;
				cursor: pointer;
				padding-left: 25px;

				&:hover {
					border-radius: 10px;
					background: #ff5967;
					color: #ffffff;
				}
			}
		}
	}

	.main-header {
		display: flex;
		width: 100%;
		min-width: 1680px;
		max-width: 1920px;
		position: sticky;
		top: 0;
		left: 0;
		z-index: 100;

		input {
			outline: none !important;
		}

		.custom-header {
			flex: 1;
			// width: 100%;
			// max-width:1920px;
			height: 80px;
			background: white;
			display: flex;
			justify-content: space-between;
			align-items: center;
			position: relative;
			padding: 0 80px 0 53px;
			// border-bottom:1px solid #E8E8EB;
			// overflow:auto;
			.logo {
				display: block;
				width: 152px;
				height: 43px;
			}

			.login-box {
				display: flex;
				align-items: center;
				justify-content: center;

				.login-btn {
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
					margin-left: 10px;
					cursor: pointer;
					color: #000000;
				}
			}

			.search {
				flex: 0 0 40%;
				display: flex;
				align-items: center;
				// position: relative;
				max-height: 48px;
				height: 100%;
				padding: 16px 0;
				// margin-left: 50px;
				background: #f7f7f7;
				border-radius: 24px;
				&.hidden{
					background: transparent;
				}
				.search-input {
					flex: 1;
					border: none !important;
					background: transparent;
					height: 100%;
					padding-left: 25px;
					padding-right: 5px;
				}

				.search-ico {
					width: 21px;
					height: 21px;
					margin-right: 25px;
					margin-left: 10px;
					cursor: pointer;
				}
			}

			.menu {
				display: flex;
				align-items: center;
				height: 100%;
				font-size: 16px;
				// flex: 0 0 20%;
				overflow-x: auto;
				column-gap: 40px;
				// margin-left:30px;
				.menu-item {
					position: relative;
					// overflow:hidden;
					// text-overflow:ellipsis;
					white-space: nowrap;
					// flex: 0 0 33.3%;
					// margin-right: 40px;
					// text-align: center;
					color: #8b8b8b;
					cursor: pointer;

					&.active {
						font-weight: bold;
						color: #000000;
					}

					.badge {
						position: absolute;
						top: -20px;
						left: 20px;
						padding: 2px 4px;
						background-color: #F9343E;
						color: white;
						font-size: 12px;
						border-radius: 8px 8px 8px 0px;
					}
				}

				&::-webkit-scrollbar {
					display: none !important;
				}
			}

			.right-box {
				display: flex;
				align-items: center;

				.creator-pop {
					::v-deep .ivu-poptip-content .ivu-poptip-arrow {
						display: none !important;
					}
				}

				.creator-btn {
					border-radius: 10px !important;
					background: #000000;
					border: none !important;
					color: #ffffff;
					height: 38px;
					font-size: 16px;
					margin-right: 30px;
				}

				.btn-wrap {
					display: flex;
					flex-wrap: nowrap;
					align-items: center;

					.msg-box {
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						margin-right: 30px;

						.icon-msg {
							width: 30px;
							height: 30px;
							cursor: pointer;
						}

						.msg-num {
							top: -5px;
							right: -5px;
							position: absolute;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 12px;
							width: 16px;
							height: 16px;
							background: #ff5967;
							border-radius: 100%;
							color: #ffffff;
						}
					}

					.avatar {
						width: 38px;
						height: 38px;
						border-radius: 50%;
						cursor: pointer;
						object-fit: cover;
					}

					.btn {
						margin: 0 5px;

						&.btn-home {
							background: #edeff2;
							color: #fa3d5a;
						}

						&.btn-start {
							background: #fa3d5a;
							color: white;
						}
					}

					.avatar-dropdown-box {
						background: #ffffff;
						border-radius: 15px;
						z-index: 999999;

						.dropdown-top {
							border-bottom: 1px solid #ebebeb;

							.dropdown-nick-avatar {
								padding: 20px 30px;
								display: flex;
								align-items: center;

								.dropdown-avatar {
									width: 52px;
									height: 52px;
									border-radius: 100%;
									object-fit: cover;
								}

								.dropdown-nick-job {
									margin-left: 10px;

									.dropdown-nick {
										width: 100%;
										font-size: 16px;
										color: #1c1f23;
									}

									.dropdown-job {
										font-size: 12px;
										color: #8b8b8b;
										width: 100%;
									}
								}
							}
						}

						.dropdown-items-lists {
							padding: 30px 35px 0 35px;
							// padding-top: 30px;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;
							width: 100%;

							.dropdown-item {
								display: flex;
								justify-content: center;
								align-items: center;
								flex-wrap: wrap;
								width: 45px;
								flex: 0 0 33.3%;
								cursor: pointer;
								padding: 0 25px 30px 25px;
								color: #5c5c5c;

								.dropdown-item-icon {
									width: 45px;
									height: 45px;
								}

								.dropdown-item-title {
									margin-top: 10px;
									font-size: 12px;
								}

								&:hover {
									color: #ff7300;
								}
							}
						}

						.dropdown-logout {
							border-top: 1px solid #ebebeb;
							width: 100%;

							.dropdown-logout-btn {
								cursor: pointer;
								text-align: center;
								width: 100%;
								padding: 20px;
								color: #808080;
								font-size: 12px;
							}
						}
					}
				}
			}

			.btn {
				width: 110px;
				height: 30px;
				line-height: 30px;
				background: #fa3d5a;
				border-radius: 20px;
				font-size: 14px;
				text-align: center;
				cursor: pointer;
				color: white;
			}
		}
	}

	@media screen and (min-width: 1280px) and (max-width: 1679px) {
		.main-header {
			min-width: 1280px;

			.custom-header {
				height: 70px;
				padding: 0 50px 0 40px;

				.logo {
					width: 130px;
					height: 36px;
				}

				.search {
					flex: 0 0 35%;
					max-height: 42px;
					padding: 14px 0;
					border-radius: 20px;

					.search-input {
						padding-left: 20px;
					}

					.search-ico {
						width: 18px;
						height: 18px;
						margin-right: 20px;
					}
				}

				.menu {
					font-size: 16px;
					column-gap: 25px;
				}

				.right-box {
					.creator-btn {
						height: 34px;
						font-size: 14px;
						margin-right: 20px;
					}

					.btn-wrap {
						.msg-box {
							margin-right: 20px;

							.icon-msg {
								width: 24px;
								height: 24px;
							}
						}

						.avatar {
							width: 34px;
							height: 34px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1279px) {
		.main-header {
			min-width: 320px;

			.custom-header {
				height: 60px;
				padding: 0 40px 0 30px;

				.logo {
					width: 120px;
					height: 32px;
				}

				.search {
					flex: 0 0 30%;
					max-height: 38px;
					padding: 12px 0;
					border-radius: 18px;

					.search-input {
						padding-left: 18px;
					}

					.search-ico {
						width: 16px;
						height: 16px;
						margin-right: 18px;
					}
				}

				.menu {
					font-size: 16px;
					column-gap: 20px;
				}

				.right-box {
					.creator-btn {
						height: 30px;
						font-size: 13px;
						margin-right: 18px;
					}

					.btn-wrap {
						.msg-box {
							margin-right: 18px;

							.icon-msg {
								width: 18px;
								height: 18px;
							}
						}

						.avatar {
							width: 32px;
							height: 32px;
						}
					}
				}
			}
		}
	}
</style>
